import React, { ReactElement, useState } from 'react';
import styled from 'styled-components';
import { HorizontalSpacing } from '../../common/spacings';
import { screen } from '../../common/breakpoints';
import { NeutralColors } from '../../common/colors';

const StyledScrollToTopContainer = styled.div`
  display: flex;
  align-items: center;

  @media screen and ${screen.l} {
    padding-right: ${HorizontalSpacing.L};
  }

  @media screen and ${screen.xl} {
    padding-right: ${HorizontalSpacing.XL};
  }
`;

const StyledButton = styled.button`
  border: 1px solid rgba(0, 0, 0, 1);
  cursor: pointer;
  background-color: white;
  width: 24px;
  padding: 5px;

  &:hover {
    background-color: ${NeutralColors.LightGray};
    transition: all 0.3s ease;
  }
`;

const StyledArrows = styled.span`
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  display: flex;
  justify-content: center;
`;

export const ScrollToTop = (): ReactElement => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <StyledScrollToTopContainer data-testid="scrollToTop-container">
      <StyledButton
        type="button"
        onClick={scrollToTop}
        hidden={!visible}
        data-testid="scrollToTop-button"
      >
        <StyledArrows>&#8594;</StyledArrows>
      </StyledButton>
    </StyledScrollToTopContainer>
  );
};
